<template>
  <l-popup class="container-lg">
    <b-row>
      <b class="text-center">{{ m.text }}</b>
    </b-row>
    <b-row>
      <b-button class="text-center" size="sm" @click="goToSalesforceReference(m.id)">Vers Salesforce</b-button>
    </b-row>
    <b-row>
      Chiffre d'affaires : {{ m.chiffreAffaires }}
    </b-row>
    <b-row>
      Opportunités : {{ m.nombreOpportunitesGagnees }}
    </b-row>
    <b-row>
      Type : {{ m.type }}
    </b-row>
    <b-row>
      Commercial terrain : {{ m.CT }}
    </b-row>
    <b-row>
      Chargé d'affaires : {{ m.CA }}
    </b-row>
    <b-row>
      Typologie : {{ m.typology }}
    </b-row>
    <b-row v-if="Object.prototype.hasOwnProperty.call(m, 'departementFromPostalCode')  && m.departementFromPostalCode !== undefined">
      <div v-if="Object.prototype.hasOwnProperty.call(m.departementFromPostalCode, 'nom')">
        Code postal : {{ m.departementFromPostalCode.nom }}
      </div>
    </b-row>
  </l-popup>
</template>

<script>
  import { LPopup } from "vue2-leaflet";

  export default {
    name: 'MarkerComponent',
    props: {
      m: Object,
      salesforceBaseUrl: {
        type: String,
        default: process.env.VUE_APP_SALESFORCE_API_BASE_URL
      },
      salesforceAccountPrefix: {
        type: String,
        default: process.env.VUE_APP_SALESFORCE_API_ACCOUNT_PREFIX
      },
      salesforceAccountSuffix: {
        type: String,
        default: process.env.VUE_APP_SALESFORCE_API_ACCOUNT_SUFFIX
      }
    },
    components: {
      LPopup
    },
    methods: {
      async goToSalesforceReference (siteId) {
        if (siteId !== '' && siteId !== null) {
          let url = this.salesforceBaseUrl + this.salesforceAccountPrefix + siteId  + "/" + this.salesforceAccountSuffix;
          window.open(url, '_blank');
        }
      },
    }
  }
</script>

<style scoped>

</style>